<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-3">
                                        <b-form-input
                                            v-model="filter"
                                            class="form-control"
                                            type="search"
                                            :placeholder="$t('label.search')"
                                            v-on:change="searchListing"
                                            autocomplete="off"
                                        />
                                    </div>
                                    <div class="col-md-8"></div>
                                    <div class="col-md-1 d-flex justify-content-end align-items-center">
                                        <b-button
                                            variant="secondary"
                                            class="mr-1"
                                            @click="searchListing"
                                            :disabled="!status.list && loading"
                                            :title="$t('label.refresh')"
                                            v-b-tooltip:hover
                                        >
                                            <i class="mdi mdi-refresh"></i>
                                        </b-button>
                                        <b-dropdown
                                            variant="warning"
                                            no-caret
                                            right
                                            menu-class="dropdown-menu-250"
                                        >
                                            <template #button-content>
                                                <i class="mdi mdi-filter"></i>
                                            </template>
                                            <div class="px-3 pb-2">
                                                <label class="small text-muted mb-1">
                                                    Method
                                                </label>
                                                <multiselect
                                                    v-model="methodFilter"
                                                    track-by="value"
                                                    label="text"
                                                    :placeholder="'Select'"
                                                    :select-label="'Select'"
                                                    :selected-label="'Selected'"
                                                    :deselect-label="'Select'"
                                                    :options="methodDdl"
                                                    :searchable="true"
                                                    :allow-empty="false"
                                                    @input="searchListing"
                                                />
                                            </div>
                                        </b-dropdown>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                v-if="status.list && !loading"
                                :items="tableRows"
                                :fields="fields"
                                :per-page="perPage"
                                responsive="sm"
                            >
                                <template #cell(method)="data">
                                    <b-badge :variant="getMethodVariant(data.item.method)">{{ getMethodText(data.item.method) }}</b-badge>
                                </template>
                                <template #cell(purpose)="data">
                                    <span>{{ data.item.purpose ? data.item.purpose : '--' }}</span>
                                </template>
                                <template #cell(subject)="data">
                                    <span>
                                        {{ data.item.subject ? data.item.subject.length > 40 ? data.item.subject.substring(0, 40) + '...' : data.item.subject : '--' }}
                                    </span>
                                </template>
                                <template #cell(from)="data">
                                    <span>{{ data.item.from ? data.item.from : '--' }}</span>
                                </template>
                                <template #cell(to)="data">
                                    <span>{{ data.item.to ? data.item.to : '--' }}</span>
                                </template>
                                <template #cell(cc)="data">
                                    <span>{{ data.item.cc ? data.item.cc : '--' }}</span>
                                </template>
                                <template #cell(bcc)="data">
                                    <span>{{ data.item.bcc ? data.item.bcc : '--' }}</span>
                                </template>
                                <template #cell(isUsed)="data">
                                    <b-badge :variant="data.item.isUsed ? 'success' : 'secondary'">
                                        {{ data.item.isUsed ? $t('label.yes') : $t('label.no') }}
                                    </b-badge>
                                </template>
                                <template #cell(actions)="data">
                                    <a
                                        href="javascript:void(0);"
                                        :class="[data.item.requestLog ? 'text-warning' : 'text-secondary']"
                                        v-b-tooltip.hover
                                        :title="$t('module.requestLog')"
                                        v-on:click="data.item.requestLog ? openRequestLog(data.item) : ''"
                                    >
                                        <i class="mdi mdi-web font-size-18"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info ml-1"
                                        v-b-tooltip.hover
                                        :title="$t('label.detail')"
                                        v-on:click="openForm(data.item)"
                                    >
                                        <i class="mdi mdi-eye font-size-18"></i>
                                    </a>
                                </template>
                            </b-table>
                            <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                            </div>
                            <b-alert
                                v-if="tableRows.length == 0 && status.list && !loading"
                                show
                                variant="warning"
                                class="mt-0 text-center"
                            >
                                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                            </b-alert>
                        </div>
                        <div v-if="totalPage" class="d-flex flex-column flex-md-row justify-content-md-between align-items-center">
                            <small class="text-muted">{{ $t('label.total') }}: {{ totalPage }}</small>
                            <b-pagination
                                v-model="currentPage"
                                :total-rows="totalPage"
                                :per-page="perPage"
                                v-on:change="pageNavigation"
                                variant="info"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="communication-log-form"
            :title="$t('label.viewX', [$t('module.communicationLog')])"
            @hidden="closeForm"
            hide-footer
            hide-header-close
            size="xl"
            centered
        >
            <b-container fluid>
                <CommunicationLogForm
                    :communicationLog="communicationLog"
                    @done="closeForm"
                    ref="communicationLogForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="communication-request-log-form"
            :title="$t('label.viewX', [$t('module.requestLog')])"
            @hidden="closeRequestLog"
            hide-footer
            hide-header-close
            size="xl"
            centered
        >
            <b-container fluid>
                <RequestLogForm
                    :requestLog="requestLog"
                    @done="closeRequestLog"
                    ref="requestLogForm"
                />
            </b-container>
        </b-modal>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import i18n from "@/i18n";
import { SESSION, SHARED } from "@/constants";
import { sessionHelper, ddlHelper } from "@/utils";
import { mapState } from "vuex";
import { communicationLogMethods } from "@/state/api";
import { COMMUNICATION_LOG_MODULE } from "@/state/api/communicationLog.state";
import CommunicationLogForm from "@/views/pages/admin/diagnostic/communicationLog/communicationLogForm";
import RequestLogForm from "@/views/pages/admin/diagnostic/requestLog/requestLogForm";

export default {
    components: { Multiselect, CommunicationLogForm, RequestLogForm },
    created() {
        sessionHelper.clearSearch(SESSION.COMMUNICATION_LOG_SEARCH) // clear search whenever page reload
        this.initSearchCriteria();

        this.loading = false;
    },
    data() {
        return {
            filter: "",
            currentPage: 1,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            methodDdl: [
                ddlHelper.getOptionAll(),
                { value: 1, text: 'email' },
                { value: 2, text: 'whatsapp' },
                { value: 3, text: 'others' },
            ],
            methodFilter: ddlHelper.getOptionAll(),
            fields: [
                { key: 'createdAt', label: i18n.t("label.createdAt"), sortable: true, class: 'text-nowrap' },
                { key: 'method', label: 'Method', sortable: true, class: 'text-nowrap' },
                { key: 'purpose', label: 'Purpose', sortable: true, class: 'text-nowrap' },
                { key: 'subject', label: 'Subject', sortable: true, class: 'text-nowrap' },
                { key: 'from', label: 'From', sortable: true, class: 'text-nowrap' },
                { key: 'to', label: 'To', sortable: true, class: 'text-nowrap' },
                { key: 'cc', label: 'CC', sortable: true, class: 'text-nowrap' },
                { key: 'bcc', label: 'BCC', sortable: true, class: 'text-nowrap' },
                { key: 'isUsed', label: 'Used', sortable: true, class: 'text-nowrap' },
                { key: 'actions', label: i18n.t("label.action"), sortable: false, class: 'text-nowrap' },
            ],
            searchCriteria: {},
            communicationLog: this.defaultCommunicationLog(),
            requestLog: this.defaultRequestLog(),
            loading: true,
        };
    },
    methods: {
        ...communicationLogMethods,
        defaultRequestLog() {
            return {
                uuid: "",
                method: "",
                path: "",
                files: null,
                requestPayload: null,
                responsePayload: null,
                ip: "",
                url: "",
                scheme: "",
                host: "",
                port: "",
                cookies: null,
                userAgent: "",
                statusCode: "",
                success: false,
                performance: null,
                createdAt: "",
                updatedAt: "",
                user: null,
                errorLog: null,
            };
        },
        defaultCommunicationLog() {
            return {
                uuid: "",
                method: "",
                purpose: "",
                from: "",
                to: "",
                cc: "",
                bcc: "",
                payload: null,
                subject: "",
                isUsed: false,
                isActive: false,
                createdAt: "",
                createdBy: "",
                updatedAt: "",
                updatedBy: "",
                deletedAt: "",
                deletedBy: "",
                user: null,
                requestLog: null,
            };
        },
        initSearchCriteria() {
            let isDefault = true;
            if(sessionHelper.hasSearchCriteria(SESSION.COMMUNICATION_LOG_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.COMMUNICATION_LOG_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
            }
            if(isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    searchValue: "",
                    searchArray: [],
                };
            }
            this.getCommunicationLogList(this.searchCriteria);
        },
        getCommunicationLogList(filter) {
            this.getAllCommunicationLog({filter});
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.COMMUNICATION_LOG_SEARCH, filter);
        },
        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.COMMUNICATION_LOG_SEARCH);
            filter.pageNumber = pageNumber;
            this.getCommunicationLogList(filter);
        },
        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            if (this.methodFilter?.value == SHARED.DEFAULT_ALL_VALUE)
                delete this.searchCriteria.method;
            else if (this.methodFilter?.value)
                this.searchCriteria.method = this.methodFilter.value;

            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            this.getCommunicationLogList(this.searchCriteria);
        },
        openForm(data) {
            if (data?.uuid) {
                this.communicationLog = {
                    ...this.defaultCommunicationLog(),
                    ...data,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('communication-log-form');
            });
        },
        closeForm() {
            this.communicationLog = this.defaultCommunicationLog();
            this.$bvModal.hide('communication-log-form');
        },
        openRequestLog(data) {
            if (data?.requestLog) {
                this.requestLog = {
                    ...this.defaultRequestLog(),
                    ...data.requestLog,
                };
            }
            this.$nextTick(() => {
                this.$bvModal.show('communication-request-log-form');
            });
        },
        closeRequestLog() {
            this.requestLog = this.defaultRequestLog();
            this.$bvModal.hide('communication-request-log-form');
        },
        getMethodText(method) {
            if(method == 1) return 'email';
            if(method == 2) return 'whatsapp';
            return 'other';
        },
        getMethodVariant(method) {
            if(method == 1) return 'info';
            if(method == 2) return 'success';
            return 'secondary';
        },
    },
    computed: {
        ...mapState(COMMUNICATION_LOG_MODULE, ['status']),
        tableRows() {
            return this.$store.state.api.communicationLog.list.data || [];
        },
        totalPage() {
            return this.$store.state.api.communicationLog.list.pagination.total || 0;
        },
    },
}
</script>
